import React from 'react';

export default function Badge({
  bgColor = 'bg-gray-200',
  textColor = 'text-gray-500',
  icon,
  text,
  border
}) {
  return (
    <span className={`${bgColor} ${textColor} border ${typeof border === 'string' && border ? border : 'border-transparent'} inline-flex justify-center items-center px-2.5 xpy-0.5 text-[10px] xfont-semibold tracking-wide uppercase rounded-full shadow-sm`} >
      {icon ? `<img src='${icon}' alt=${text} width="15" height="15" className="mr-1" />` : ''}
      <span className="whitespace-nowrap">{text}</span>
    </span >
  );
}
